import React, {useRef} from 'react';

import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import './ForgotPassword.scss';
import {useDispatch} from 'react-redux';
import {resetPasswordACS} from 'store/app/requestAC';
import {setModalAC} from 'store/modal/modalSlice';

export const ForgotPassword = () => {
  const dispatch = useDispatch();
  const emailRef = useRef<HTMLInputElement | null>(null);

  const handleClose = () => {
    dispatch(setModalAC(null));
  };

  const handleSubmit = () => {
    if (!emailRef.current) return;

    dispatch(resetPasswordACS({data: {email: emailRef.current.value.trim()}}));
  };

  return (
    <div className="forgot-password">
      <div className="forgot-password__icon">
        <Icon icon="forgot_password_lock" />
      </div>

      <h3 className="forgot-password__title">Forgot Password?</h3>
      <p className="forgot-password__description">
        Enter your registered email below to receive password reset instruction.
      </p>

      <div className="forgot-password__form">
        <div className="forgot-password__form-wrapper">
          <label htmlFor="email">Email</label>
          <input ref={emailRef} type="text" id="email" placeholder="Email Address" />
        </div>
      </div>

      <div className="forgot-password__buttons">
        <Button variant="white" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Continue
        </Button>
      </div>
    </div>
  );
};
